import styles from './ContainerDivider.module.css'

export default function ContainerDivider() {
  return (
    <div className={styles.base}>
      <hr />
    </div>
  )
}
